module.exports = __webpack_public_path__ + "static/media/sunil_sharma.fe3912ed.png";